import { styled } from "@material-ui/core";

export const styledListIcon = (component: React.ElementType<any>) =>
  styled(component)(({ theme }) => ({
    minWidth: 0,
    marginRight: theme.spacing(2),
  }));
